import { useState } from "react";
import { adminChangePassword } from "../../lib/api";

export default function AdminChangePassword() {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(""); setOk(false);
    if (next.length < 10) { setError("New password must be at least 10 characters."); return; }
    if (next !== confirm) { setError("New passwords do not match."); return; }
    setBusy(true);
    try {
      await adminChangePassword(cur, next);
      setOk(true); setCur(""); setNext(""); setConfirm("");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Password change failed");
    } finally { setBusy(false); }
  }

  return (
    <div data-testid="admin-password-page" className="max-w-md space-y-6">
      <header>
        <h1 className="font-serif-display italic text-2xl md:text-3xl text-white/85">Change password</h1>
      </header>
      <form onSubmit={submit} className="space-y-6" data-testid="admin-password-form">
        <label className="block">
          <span className="block text-xs uppercase tracking-[0.22em] text-white/45 mb-1 font-serif-display italic">Current password</span>
          <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className="q-input" data-testid="admin-password-current" />
        </label>
        <label className="block">
          <span className="block text-xs uppercase tracking-[0.22em] text-white/45 mb-1 font-serif-display italic">New password</span>
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={10} className="q-input" data-testid="admin-password-new" />
        </label>
        <label className="block">
          <span className="block text-xs uppercase tracking-[0.22em] text-white/45 mb-1 font-serif-display italic">Confirm new password</span>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={10} className="q-input" data-testid="admin-password-confirm" />
        </label>
        {error && <p className="text-sm text-red-300/85 font-serif-display italic" data-testid="admin-password-error">{error}</p>}
        {ok && <p className="text-sm text-emerald-300/85 font-serif-display italic" data-testid="admin-password-success">Password updated.</p>}
        <button type="submit" disabled={busy} className="btn-ghost disabled:opacity-40" data-testid="admin-password-submit">
          {busy ? "Saving…" : "Update password"}
        </button>
      </form>
    </div>
  );
}
